export default "__VITE_ASSET__CKeYF8VC__"